import './item.css';
import 'react-datepicker/dist/react-datepicker.css';

import * as React from 'react';
import DatePicker from 'react-datepicker';
import Utility from 'src/common/Utility';
import BoardItem from 'src/entities/BoardItem';
import Member from 'src/entities/Member';

import CancelWhite from '../../res/img/cancel_white.svg';
import CheckGreen from '../../res/img/check_green.svg';
import Profile from '../../res/img/member.svg';

interface IProps {
  account: Member;
  members: Member[];
  member: Member;
  item: BoardItem;
  destroyItem: (item: BoardItem) => void;
  updateItem: (item: BoardItem) => void;
  isWatcher: boolean;
}

interface IState {
  item: BoardItem;
  isEditing: boolean;
}

class ItemComponent extends React.Component<IProps, IState> {
  editText: HTMLTextAreaElement;
  editDeadline: HTMLInputElement;

  constructor(props: any) {
    super(props);
    this.state = {
      item: JSON.parse(JSON.stringify(this.props.item)),
      isEditing: false
    };

    this.onChangeItemText = this.onChangeItemText.bind(this);
    this.onChangeItemDeadline = this.onChangeItemDeadline.bind(this);
    this.onChangeItemMember = this.onChangeItemMember.bind(this);
    this.updateItem = this.updateItem.bind(this);
    this.destroyItem = this.destroyItem.bind(this);
    this.startEditing = this.startEditing.bind(this);
    this.cancelEditing = this.cancelEditing.bind(this);
    this.toggleCompleted = this.toggleCompleted.bind(this);
  }

  componentDidUpdate() {
    if (this.state.item.updated !== this.props.item.updated) {
      this.setState({
        item: JSON.parse(JSON.stringify(this.props.item))
      });
    }
  }

  render() {
    const isOverDeadline =
      !this.state.item.completed && this.state.item.deadline < Date.now()
        ? true
        : false;

    if (!this.state.isEditing) {
      return (
        <div
          className={!isOverDeadline ? 'BoardItem' : 'BoardItem OverDeadline'}
          onDoubleClick={this.startEditing}
        >
          {this.props.account.id === this.state.item.memberId ? (
            <div className="Cancel" onClick={this.destroyItem}>
              <img src={CancelWhite} />
            </div>
          ) : null}

          <div className="Member">
            {this.state.item.completed ? (
              <img src={CheckGreen} onClick={this.toggleCompleted} />
            ) : (
              <img
                onClick={this.toggleCompleted}
                src={
                  this.props.member.profile !== null
                    ? this.props.member.profile
                    : Profile
                }
              />
            )}
            <span>{this.props.member.nameLast}</span>
          </div>
          <div className="Content">
            <div className="Text">{Utility.nl2br(this.state.item.text)}</div>
            <div className="Deadline">
              {Utility.dateFormat(new Date(this.state.item.deadline), 'M月d日')}
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="BoardItem">
          <div className="Cancel" onClick={this.cancelEditing}>
            <img src={CancelWhite} />
          </div>
          <div className="Member">
            <img
              src={
                this.props.member.profile !== null
                  ? this.props.member.profile
                  : Profile
              }
            />
            <select
              className="SelectMember"
              onChange={this.onChangeItemMember}
              defaultValue={String(this.state.item.memberId)}
            >
              {this.props.members.map(member => (
                <option value={String(member.id)}>{member.nameLast}</option>
              ))}
            </select>
          </div>
          <div className="Content">
            <textarea
              value={this.state.item.text}
              onChange={this.onChangeItemText}
            />
            <div className="ContentBottom">
              <DatePicker
                selected={new Date(this.state.item.deadline)}
                onChange={this.onChangeItemDeadline}
                dateFormat="MM月dd日"
              />
              {/* <input
                type="date"
                value={Utility.dateFormat(
                  new Date(this.state.item.deadline),
                  "yyyy-MM-dd"
                )}
                onChange={this.onChangeItemDeadline}
              /> */}
              <button className="Edit" onClick={this.updateItem}>
                編集
              </button>
            </div>
          </div>
        </div>
      );
    }
  }

  onChangeItemText(e: any) {
    const item = Object.assign({}, this.state.item);
    this.setState({
      item: {
        ...item,
        text: e.target.value
      }
    });
  }

  onChangeItemDeadline(date: any) {
    const item = Object.assign({}, this.state.item);
    this.setState({
      item: {
        ...item,
        deadline: Date.parse(date)
      }
    });
  }

  onChangeItemMember(e: any) {
    const item = Object.assign({}, this.state.item);
    this.setState({
      item: {
        ...item,
        memberId: Number(e.target.value)
      }
    });
  }

  updateItem(e: any) {
    const item = Object.assign({}, this.state.item);
    if (item.text.length > 0 && !isNaN(item.deadline)) {
      this.setState({
        isEditing: false
      });
      this.props.updateItem(item);
    }

    if (item.text.length === 0) {
      alert('項目が空になっています');
    }

    if (isNaN(item.deadline)) {
      alert('期限を設定されていません');
    }
  }

  destroyItem(e: any) {
    if (this.props.account.id === this.state.item.memberId) {
      this.props.destroyItem(this.state.item);
    }
  }

  startEditing(e: any) {
    if (!this.props.isWatcher) {
      this.setState({
        isEditing: true
      });
    }
  }

  cancelEditing(e: any) {
    this.setState({
      isEditing: false
    });
  }

  toggleCompleted(e: any) {
    if (
      this.props.account.id === this.state.item.memberId ||
      this.props.account.isSystemAdmin === true
    ) {
      const item = Object.assign({}, this.state.item);
      item.completed = !item.completed;
      this.props.updateItem(item);
    } else {
      alert('作成者のみが変更できます');
    }
  }
}

export default ItemComponent;



// WEBPACK FOOTER //
// ./src/components/Board/item.tsx